export function convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }
  
  export function formatFileSize(bytes: number): string {
    if (bytes === 0) return "0 Bytes";

    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const formattedSize = (bytes / Math.pow(1024, i)).toFixed(2);

    return `${formattedSize} ${sizes[i]}`;
}

export function shortenFileName(fileName: string): string {
  // Remove extension (.docx, .pdf, etc.) by capturing everything before the last dot
  const lastDotIndex = fileName.lastIndexOf('.');
  let baseName = fileName;
  if (lastDotIndex > 0) {
    baseName = fileName.substring(0, lastDotIndex);
  }

  // Trim extra spaces
  baseName = baseName.trim();

  // Optionally, you could do more transformations (replacing multiple spaces, etc.)
  // But for now, just return the trimmed name
  return baseName;
}

export function downloadAttachment(message: { attachmentUrl?: string; attachmentType?: string }) {
    try {
        if (!message.attachmentUrl) throw new Error("No attachment URL found");

        // Extract filename from URL
        let fileName = "download";
        try {
            const urlPath = new URL(message.attachmentUrl).pathname;
            fileName = decodeURIComponent(urlPath.substring(urlPath.lastIndexOf("/") + 1));
        } catch {
            const extension = message.attachmentType || "bin";
            fileName = `file.${extension}`;
        }

        // Create hidden <a> to download
        const link = document.createElement("a");
        link.href = message.attachmentUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (err) {
        console.error("Download failed:", err);
    }
}